import { createSlice } from '@reduxjs/toolkit';
import { generateSetEditId } from '../../generators/generateReducers';
import { generateStateSingle } from '../../generators/generateState';
import {
    createData,
    deleteData,
    editData,
    fetchData,
    fetchEditData,
} from '../../generators/generateThunks';
const SLICE_NAME = 'organization';

export const fetchOrganizations = fetchData.generateThunk(
    SLICE_NAME,
    SLICE_NAME
);
export const editOrganization = editData.generateThunk(SLICE_NAME, SLICE_NAME);
export const fetchOrganization = fetchEditData.generateThunk(
    SLICE_NAME,
    SLICE_NAME
);
export const deleteOrganization = deleteData.generateThunk(
    SLICE_NAME,
    SLICE_NAME
);
export const createOrganization = createData.generateThunk(
    SLICE_NAME,
    SLICE_NAME
);

const organizationSlice = createSlice({
    name: SLICE_NAME,
    initialState: generateStateSingle(SLICE_NAME),
    reducers: {
        setEditId: generateSetEditId(),
    },
    extraReducers: {
        ...fetchData.generateExtraReducers(fetchOrganizations, SLICE_NAME),
        ...createData.generateExtraReducers(createOrganization, SLICE_NAME),
        ...deleteData.generateExtraReducers(deleteOrganization, SLICE_NAME),
        ...fetchEditData.generateExtraReducers(fetchOrganization, SLICE_NAME),
        ...editData.generateExtraReducers(editOrganization, SLICE_NAME),
    },
});

export const getOrganization = (state) => state.organization;
export const { setEditId } = organizationSlice.actions;
export default organizationSlice.reducer;
